export async function catchError<T>(
  promise: Promise<T>,
): Promise<[T, null] | [null, Error]> {
  try {
    const data = await promise
    return [data, null]
  } catch (error) {
    logError(error)
    return [null, error instanceof Error ? error : new Error(String(error))]
  }
}

export function catchErrorSync<T>(fn: () => T): [T, null] | [null, Error] {
  try {
    const data = fn()
    return [data, null]
  } catch (error) {
    logError(error)
    return [null, error instanceof Error ? error : new Error(String(error))]
  }
}
